export type ProtectedRouteAuthState = "loading" | "signed-out" | "signed-in";

export function resolveProtectedRouteAuthState(
  isLoaded: boolean,
  isSignedIn: boolean | undefined,
): ProtectedRouteAuthState {
  if (!isLoaded) return "loading";
  return isSignedIn ? "signed-in" : "signed-out";
}
